import Slider from "react-slick";
import styled from "styled-components";
import {
  FPassword,
  LoginSVG,
  StockSVG,
  SalesSVG,
} from "../../assets/svg/SvgIcons";

const ItemSlider: any = Slider as any;

const settings = {
  // fade: true,
  autoplay: true,
  speed: 1000,
  pauseOnHover: false,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  arrows: false,
  dots: true,
};

function InfoTile({ data }: any) {
  const { title, desc, image, width } = data;
  return (
    <Wrapper className="whiteColor flexCenter flexColumn textCenter gap20">
      <SliderImg src={image} alt="image" width={width} />

      <div className="flexCenter flexColumn gap20" style={{ maxWidth: 500 }}>
        <h2>{title}</h2>
        <div className="font13">{desc}</div>
      </div>
    </Wrapper>
  );
}

const infoData = [
  {
    image: LoginSVG,
    title: "Login",
    desc: (
      <p>
        Welcome to the inventory portal. Log in to access the inventory
        dashboard, track stock levels, and manage system operations
      </p>
    ),
  },
  {
    image: StockSVG,
    title: "Stock Management",
    desc: (
      <p>
        Track stock levels, monitor items in real time, and manage supply
        update. <b>Real-time counts:</b> View live stock levels as items move.{" "}
        <b>Item tracking:</b> Follow products from entry to dispatch.{" "}
        <b>Supply updates:</b> Get alerts for low stock fast.
      </p>
    ),
  },
  {
    image: SalesSVG,
    title: "Purchase Orders and Sales",
    desc: (
      <p>
        Securely manage your stock, track orders in real-time, and optimize
        fulfillment from one centralized dashboard.
        <b>Real-time visibility</b> into stock levels and warehouse movement.{" "}
        <b>Automated alerts</b> to prevent stockouts and overstocking.
        <b>Streamlined workflows</b> for faster order processing and fulfillment
      </p>
    ),
  },
  {
    image: FPassword,
    title: "Forgot Your Password",
    desc: (
      <p>
        Have you forgotten your login Zimba password? Click on the
        <b> Forgotten Password </b> option or contact our{" "}
        <b> Help & Support </b>
        team for assistance.
      </p>
    ),
  },
];

export default function InfoSlider() {
  return (
    <>
      {/* Slider */}
      <div
        data-aos="fade-up"
        data-aos-duration="1500"
        style={{ height: "100%" }}
      >
        <ItemSlider {...settings}>
          {infoData.map((val, key) => {
            return <InfoTile data={val} key={key} />;
          })}
        </ItemSlider>
      </div>
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;
  min-height: 600px;
  padding: 40px;
`;

const SliderImg = styled.img`
  width: ${(props) => (props.width ? props.width : "350px")};
  marginbottom: 20px;
  @media (max-width: 760px) {
    width: ${(props) => (props.width ? props.width : "100%")};
  }
`;
